import script from "./CommissionContractTemplate.vue?vue&type=script&setup=true&lang=js"
export * from "./CommissionContractTemplate.vue?vue&type=script&setup=true&lang=js"

import "./CommissionContractTemplate.vue?vue&type=style&index=0&id=fef846fa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fef846fa"]])

export default __exports__